/* HighlightedText.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Inline } from '@atlaskit/primitives';
import { EyebrowMedium } from '@atlassian/mpac-primitives';
import React from 'react';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _17 = "._1pbykb7n{z-index:1}";
const _16 = "._1pbyidpf{z-index:0}";
const _15 = "._uiztglyw{-webkit-user-select:none;-ms-user-select:none;user-select:none}";
const _14 = "._lcxvglyw{pointer-events:none}";
const _13 = "._5ral1nqf{object-fit:fill}";
const _12 = "._1bsb1osq{width:100%}";
const _11 = "._u7coidpf{inset-block-end:0}";
const _10 = "._1e02idpf{inset-inline-start:0}";
const _9 = "._kqswstnw{position:absolute}";
const _8 = "._kqswh2mm{position:relative}";
const _7 = "._1e0c1o8l{display:inline-block}";
const _6 = "._1yt412x7{padding:var(--ds-space-075,6px)}";
const _5 = "._k48ps198{font-weight:var(--_1c6tja0)}";
const _4 = "._1p1d1kxy{text-transform:var(--_wyncpo)}";
const _3 = "._syaz1u00{color:var(--_srel9g)}";
const _2 = "._k48pni7l{font-weight:600}";
const _ = "._1dyz165v{letter-spacing:.02rem}";
const itemTextBaseStyles = null;
const highlightedWrapperStyles = null;
const highlightImgStyles = null;
const textContentWrapperStyles = null;
const HighlightedText = _ref => {
  let {
    items = [],
    separator = '·',
    color,
    uppercase = true,
    weight,
    leading,
    space = 'space.075',
    testId,
    highlight
  } = _ref;
  const textColor = color !== null && color !== void 0 ? color : "var(--ds-text, #172B4D)";
  const textTransform = uppercase ? 'uppercase' : 'none';
  const fontWeight = weight !== null && weight !== void 0 ? weight : 600;
  const content = [];
  items.forEach((item, index) => {
    content.push(/*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3, _4, _5]
      }), /*#__PURE__*/_jsx(EyebrowMedium, {
        as: "span",
        className: ax(["_1dyz165v _k48pni7l", "_syaz1u00 _1p1d1kxy _k48ps198"]),
        style: {
          "--_srel9g": ix(textColor),
          "--_wyncpo": ix(textTransform),
          "--_1c6tja0": ix(fontWeight)
        },
        children: item
      }, "item-".concat(index))]
    }, "item-".concat(index)));
    if (index < items.length - 1) {
      content.push(/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_, _2, _3, _4, _5]
        }), /*#__PURE__*/_jsx(EyebrowMedium, {
          as: "span",
          "aria-hidden": "true",
          className: ax(["_1dyz165v _k48pni7l", "_syaz1u00 _1p1d1kxy _k48ps198"]),
          style: {
            "--_srel9g": ix(textColor),
            "--_wyncpo": ix(textTransform),
            "--_1c6tja0": ix(fontWeight)
          },
          children: separator
        }, "sep-".concat(index))]
      }, "sep-".concat(index)));
    }
  });
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _7, _8]
    }), /*#__PURE__*/_jsxs("span", {
      className: ax(["_1yt412x7 _1e0c1o8l _kqswh2mm"]),
      children: [highlight ? /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_9, _10, _11, _12, _13, _14, _15, _16]
        }), /*#__PURE__*/_jsx("img", {
          src: highlight,
          alt: "",
          "aria-hidden": "true",
          className: ax(["_kqswstnw _1e02idpf _u7coidpf _1bsb1osq _5ral1nqf _lcxvglyw _uiztglyw _1pbyidpf"])
        })]
      }) : null, /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_8, _17]
        }), /*#__PURE__*/_jsx("span", {
          className: ax(["_kqswh2mm _1pbykb7n"]),
          children: /*#__PURE__*/_jsxs(Inline, {
            alignBlock: "center",
            alignInline: "center",
            shouldWrap: false,
            space: space,
            testId: testId,
            children: [leading, content]
          })
        })]
      })]
    })]
  });
};
export default HighlightedText;